export class NumberPlateModel {

    // 運輸支局
    transportBranchOffice = "";

    // 分類番号
    classNumber = "";

    // ひらがな
    hiragana = "";

    // 一連指定番号1
    number1 = "";

    // 一連指定番号2
    number2 = "";

    // 一連指定番号3
    number3 = "";

    // 一連指定番号4
    number4 = "";

    public copy(obj: NumberPlateModel) {
        if (obj) {
            this.transportBranchOffice = obj.transportBranchOffice;
            this.classNumber = obj.classNumber;
            this.hiragana = obj.hiragana;
            this.number1 = obj.number1;
            this.number2 = obj.number2;
            this.number3 = obj.number3;
            this.number4 = obj.number4;
        }
    }

    /** 表示用の一連指定番号1を返却します。 */
    public getNumber1(): string {
        return NumberPlateModel.replacePointIfNotExist(this.number1);
    }

    /** 表示用の一連指定番号2を返却します。 */
    public getNumber2(): string {
        return NumberPlateModel.replacePointIfNotExist(this.number2);
    }

    /** 表示用の一連指定番号3を返却します。 */
    public getNumber3(): string {
        return NumberPlateModel.replacePointIfNotExist(this.number3);
    }

    /** 表示用の一連指定番号4を返却します。 */
    public getNumber4(): string {
        return NumberPlateModel.replacePointIfNotExist(this.number4);
    }

    /**
     * 一連指定番号の要素が未入力の場合は「・」に置換します。
     * @param number
     * @private
     */
    private static replacePointIfNotExist(number: string): string {
        return number ? number : "・";
    }

    /**
     * 表示用の一連指定番号を返します。
     */
    public getSerialNumber() {
        if (!this.number1 && !this.number2 && !this.number3 && !this.number4) {
            return "";
        }
        return `${this.getNumber1()}${this.getNumber2()}-${this.getNumber3()}${this.getNumber4()}`;
    }

    /** 運輸支局のプレースホルダ */
    static readonly NUMBER_PLATE_PH_TRANSPORT_BRANCH_OFFICE: string = "品川" as string;
    /** 分類番号のプレースホルダ */
    static readonly NUMBER_PLATE_PH_CLASS_NUMBER: string = "123" as string;
    /** ひらがなのプレースホルダ */
    static readonly NUMBER_PLATE_PH_HIRAGANA: string = "あ" as string;
    /** 一連指定番号1のプレースホルダ  */
    static readonly NUMBER_PLATE_PH_NUMBER1: string = "・" as string;
    /** 一連指定番号2のプレースホルダ  */
    static readonly NUMBER_PLATE_PH_NUMBER2: string = "・" as string;
    /** 一連指定番号3のプレースホルダ  */
    static readonly NUMBER_PLATE_PH_NUMBER3: string = "・" as string;
    /** 一連指定番号4のプレースホルダ  */
    static readonly NUMBER_PLATE_PH_NUMBER4: string = "・" as string;

    /** ナンバープレート表示用の運輸支局 */
    public transportBranchOfficeForImage() {
        return this.transportBranchOffice ? this.transportBranchOffice : NumberPlateModel.NUMBER_PLATE_PH_TRANSPORT_BRANCH_OFFICE;
    }

    /** ナンバープレート表示用の分類番号 */
    public classNumberForImage() {
        return this.classNumber ? this.classNumber : NumberPlateModel.NUMBER_PLATE_PH_CLASS_NUMBER;
    }

    /** ナンバープレート表示用のひらがな */
    public hiraganaForImage() {
        return this.hiragana ? this.hiragana : NumberPlateModel.NUMBER_PLATE_PH_HIRAGANA;
    }

    /** ナンバープレート表示用の一連指定番号1 */
    public number1ForImage() {
        if (this.isNoSerialNumber()) {
            return NumberPlateModel.NUMBER_PLATE_PH_NUMBER1;
        } else {
            return this.number1 ? this.number1 : "・";
        }
    }

    /** ナンバープレート表示用の一連指定番号2 */
    public number2ForImage() {
        if (this.isNoSerialNumber()) {
            return NumberPlateModel.NUMBER_PLATE_PH_NUMBER2;
        } else {
            return this.number2 ? this.number2 : "・";
        }
    }

    /** ナンバープレート表示用の一連指定番号3 */
    public number3ForImage() {
        if (this.isNoSerialNumber()) {
            return NumberPlateModel.NUMBER_PLATE_PH_NUMBER3;
        } else {
            return this.number3 ? this.number3 : "・";
        }
    }

    /** ナンバープレート表示用の一連指定番号4 */
    public number4ForImage() {
        if (this.isNoSerialNumber()) {
            return NumberPlateModel.NUMBER_PLATE_PH_NUMBER4;
        } else {
            return this.number4 ? this.number4 : "・";
        }
    }

    /** 一連指定番号が未入力か判定します。 */
    public isNoSerialNumber(): boolean {
        return !this.number1 && !this.number2 && !this.number3 && !this.number4;
    }

    /**
     * ナンバープレートの運輸支局のスタイルクラスを返します。
     */
    public numberPlateOfficeClass(): string {
        return this.transportBranchOffice ? "number-plate-office" : "number-plate-office number-plate-office-none";
    }

    /**
     * ナンバープレートの分類番号のスタイルクラスを返します。
     */
    public numberPlateClassNumberClass(): string {
        return this.classNumber ? "number-plate-class" : "number-plate-class number-plate-class-none";
    }

    /**
     * ナンバープレートのひらがなのスタイルクラスを返します。
     */
    public numberPlateHiraganaClass(): string {
        return this.hiragana ? "number-plate-hiragana" : "number-plate-hiragana number-plate-hiragana-none";
    }

    /**
     * ナンバープレートの一連番号4のスタイルクラスを返します。
     */
    public numberPlateSerialNumber4(): string {
        return !this.isNoSerialNumber() ? "number-plate-serial-number" : "number-plate-serial-number number-plate-serial-number-none";
    }
}